import React from 'react';
import { Link } from 'react-router-dom';
import google from '../assets/google1.svg'
const SignUpComp = () => {
    return (
        <>
            <div className='container md:w-[60%] w-[90%] mt-10 mx-auto '>
                <div>
                    <div className='login-bg  rounded-xl mx-auto'>
                        <h1 className='text-center py-3 text-[56px] font-bold  text-white  ' > Sign Up</h1>
                    </div>

                    <div className='     '>

                        <h2 className=' text-gray-400 text-sm mr-3 float-right py-2   '><span className='text-blue-400 font-semibold'> <Link to="/Login"> Login</Link></span></h2>
                    </div>
      

                    

                   

                    <div className='w-[90%] my-7 md:w-[70%] mx-auto'>

                        <form>
                            <div class="flex flex-wrap -mx-3 mb-3">
                                <div class="w-full md:w-1/2 px-3 mb-3 md:mb-0">
                                    <label class="block   tracking-wide text-[#131436] text-xs font-semibold mb-2" htmlFor="grid-first-name">
                                        First Name
                                    </label>
                                    <input class="appearance-none block w-full rounded-2xl h-[50px] bg-[#fbfeff]  text-[#6A7D95] border text-[#272C34] text-[12px] pt-1 border-gray-300 h-[50px] px-5 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" placeholder="Enter first name" />

                                </div>
                                <div class="w-full md:w-1/2 px-3">
                                    <label class="block   tracking-wide text-[#131436] text-xs font-semibold mb-2" htmlFor="grid-last-name">
                                    Last name
                                    </label>
                                    <input class="appearance-none block w-full rounded-2xl   h-[50px] bg-[#fbfeff] text-[#6A7D95] border border-gray-300 text-xs px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" type="text" placeholder="Enter last name" />
                                </div>
                            </div>
                            <div class="mb-3">
                                <label htmlFor="email" class="block mb-2 text-xs font-medium text-[#131436]  ">Phone number</label>
                                <input type="email" id="number" class="shadow-sm px-5 h-[50px] bg-[#fbfeff] border border-gray-300 text-[#6A7D95] text-xs rounded-2xl   h-[50px] focus:bg-white focus:ring-blue-500   block w-full p-2.5      " placeholder="+000 0000 0000" required />
                            </div>
                            <div class="mb-3">
                                <label htmlFor="email" class="block mb-2 text-xs font-medium text-[#131436]  ">Email address</label>
                                <input type="email" id="email" class="shadow-sm px-5 h-[50px] rounded-2xl   h-[50px] bg-[#fbfeff] border border-gray-300 text-[#6A7D95] text-xs  focus:ring-blue-500 focus:bg-white  block w-full p-2.5     " placeholder="Enter email address" required />
                            </div>
                            <div class="mb-3">
                                <label htmlFor="password" class="block mb-2 text-xs font-medium text-[#131436]  "> Password</label>
                                <input type="text" id="password" class="shadow-sm px-5 h-[50px] bg-[#fbfeff] border border-gray-300 text-[#6A7D95] text-xs rounded-2xl   h-[50px]  w-full p-2.5 focus:bg-white   " placeholder='Enter password' required />
                            </div>



                            <center>
                                <button type="submit" class="text-white my-6  bg-blue-400 hover:bg-blue-500    font-medium rounded-xl text-xs px-16 h-[50px] text-center  ">Sign Up</button>
                            </center>
                        </form>
                    </div>

                </div>
            </div>
        </>
    )
}

export default SignUpComp